import React, { useMemo }  from 'react';

import { Route, Switch } from 'react-router-dom';

import Home from '../home';
import Error from '../error';
// import Success from '../success';

import Header from '../../../global/components/public/header';
import Footer from '../../../global/components/public/footer';
import Header_MHQP from '../../../global/components/public/header-mhqp';
import Border from '../../../global/components/public/border';

export type Paths = {
    home: string;
    error: string;
};

export const paths = {
    home: '/',
    error: '/error/:errcode',
    success: '/success'
};

export const Router: React.FC<Record<string, unknown>> = () => {

    const mhqp = useMemo(() => document.getElementById('mhqp') ? true : false, []);

    return <>
        { mhqp ? 
            <Header_MHQP /> :
            <Header inverseLogo={true} darkMode={true} /> 
        }
        <Switch>
            <Route exact path={ paths.error }>
                <Error mhqp={mhqp} />
            </Route>
            <Route path={ paths.home }>
                <Home mhqp={mhqp} />
            </Route>
        </Switch>
        <Footer mhqp={mhqp} />
        <Border />
    </>;
};